import { SelectOptionType } from 'components/common/InputSelect/inputSelect.types';

export const getOptions = (optionsEnum: Record<string, string>): SelectOptionType[] => {
  return [
    ...Object.values(optionsEnum).map((value) => ({
      value: value,
      label: value,
    })),
  ];
};
